<template>
  <div class="box">
    <div class="head">
      <Header></Header>
    </div>
    <!-- 文章内容 -->
    <div class="div">
      <div class="ThereIsNo">
        <div class="QRcode">
          <img
            src="../../../assets/images/dynamicInformation/Information/QRcode.png"
            alt=""
          />
          <p>
            微信扫一扫 <br />
            关注该公众号
          </p>
        </div>
      </div>
      <div class="essayOne">
        <h2>生态部：关于印发《关于加强排污许可执法监管的指导意见》的通知</h2>
        <div class="time"><a href="#">环保大讲坛</a>&nbsp;2022-04-12 17:08</div>
        <div class="texts">
          <!-- ------------------------------------------------------------------------------ -->
          <img
            src="../../../assets/images/dynamicInformation/Information/page4/img001.png"
            alt=""
          />
          <div
            style="
              color: #c60002;
              font-size: 17px;
              width: 100%;
              text-align: center;
            "
          >
            关于印发《关于加强排污许可执法监管的指导意见》的通知
          </div>
          <div>
            各省、自治区、直辖市人民政府，中央和国家机关有关部门和单位：
          </div>
          <p>
            《关于加强排污许可执法监管的指导意见》已经中央全面深化改革委员会审议通过。现印发给你们，请结合实际认真贯彻落实。
          </p>
          <br />
          <p>（此件社会公开）</p>
          <p>生态环境部办公厅2022年3月29日印发</p>
          <br />
          <div
            style="
              color: #000;
              font-size: 17px;
              width: 100%;
              text-align: center;
              font-weight: 700;
            "
          >
            关于加强排污许可执法监管的指导意见
          </div>
          <p>
            为贯彻落实党中央、国务院关于深入打好污染防治攻坚战有关决策部署，全面推进排污许可制度改革，加快构建以排
            污许可制为核心的固定污染源执法监管体系，持续改善生态环境质量，提出以下意见。
          </p>
          <h3>一、总体要求</h3>
          <p>
            以习近平新时代中国特色社会主义思想为指导，全面贯彻党的十九大和十九届历次全会精神，深入贯彻习近平生态
            文明思想，按照党中央、国务院决策部署，坚持精准治污、科学治污、依法治污，以固定污染源排污许可制为核心，
            创新执法理念，加大执法力度，优化执法方式，提高执法效能，构建企业持证排污、政府依法监管、社会共同监督
            的生态环境执法监管新格局，为深入打好污染防治攻坚战提供坚强保障。
          </p>
          <p>
            到2023年年底，重点行业实施排污许可清单式执法检查，排污许可日常管理、环境监测、执法监管有效联动，以排污
            许可制为核心的固定污染源执法监管体系基本形成。到2025年年底，排污许可清单式执法检查全覆盖，排污许可执法监
            管系统化、科学化、法治化、精细化、信息化水平显著提升，以排污许可制为核心的固定污染源执法监管体系全面建立。
          </p>

          <h3>二、全面落实责任</h3>
          <p>
            <span class="song">（一）压实地方政府属地责任。</span>
            设区的市级以上地方人民政府全面负责本行政区域排污许可制度组织实施工作，强化统
            筹协调，明确部门职责，加强督查督办。将排污许可制度执行情况纳入污染防治攻坚战成效考核，对排污许可监管工作
            中的失职渎职行为依法依规追究责任。建立综合监管协调机制，统筹解决无法取得环评批复、影响排污许可证核发的历
            史遗留问题，2023年年底前，原则上固定污染源全部持证排污。
            <span class="song"> （地方人民政府负责落实） </span>
          </p>
          <p>
            <span class="song">（二）强化生态环境部门监管责任。</span>
            设区的市级以上地方生态环境部门要严格落实《排污许可管理条例》，依法履行排污许可监督管理职责，谁核发、谁监管、
            谁负责。进一步增强排污许可证核发的科学性、规范性和可操作性，不断提高核发质量。加强事中事后监管，强化排污许可
            证后管理，督促排污单位落实相关制度。
            <span class="song"> （生态环境部负责） </span>
          </p>
          <p>
            <span class="song">（三）夯实排污单位主体责任。</span>
            排污单位必须依法持证排污、按证排污，建立排污许可责任制，明确责任人和责任事项，确保事有人管、责有人负。健全企
            业环境管理制度，及时申请取得、延续和变更排污许可证，完善污染防治措施，正常运行自动监测设施，提高自行监测质量。
            确保申报材料、环境管理台账记录、排污许可证执行报告、自行监测数据的真实、准确和完整，依法如实在全国排污许可证管
            理信息平台上公开信息，不得弄虚作假，自觉接受监督。
            <span class="song"> （生态环境部负责指导） </span>
          </p>

          <h3>三、严格执法监管</h3>
          <p>
            <span class="song">（四）依法核发排污许可证。</span>
            规范排污许可证申请与核发流程，加强排污许可证延续、变更、注销、撤销等环节管理。修订《排污许可管理办法（试行）》，
            发布新版排污许可证（副本），强化污染物排放直接相关的生产设施、污染防治设施管控。建立排污许可证核发包保工作机制，
            强化对地方发证工作的技术支持和帮扶指导。
            <span class="song"> （生态环境部负责） </span>
          </p>
          <p>
            <span class="song">（五）加强跟踪监管。</span>
            加强排污许可证动态跟踪监管，加大抽查指导力度。2023年年底前，生态环境部门要对现有排污许可证核发质量开展检查，依托
            全国排污许可证管理信息平台，采取随机抽取和靶向核查相结合、非现场和现场核查相结合的方式，重点检查是否应发尽发、应登
            尽登，是否违规降低管理级别，实际排污状况与排污许可证载明事项是否一致。对发现的问题，要分级分类处置，依法依规变更，动态跟踪管理。
            <span class="song"> （生态环境部负责指导） </span>
          </p>
          <p>
            <span class="song">（六）开展清单式执法检查。</span>
            推行以排污许可证载明事项为重点的清单式执法检查，重点检查排放口规范化建设、污染物排放浓度和排放量、污染防治设施运
            行和维护、无组织排放控制等要求的落实情况，抽查核实环境管理台账记录、排污许可证执行报告、自行监测数据、信息公开内
            容的真实性。生态环境部组织开展排污许可清单式执法检查试点，省级生态环境部门制定排污许可清单式执法检查实施方案，设
            区的市级生态环境部门逐步推进清单式执法检查。
            <span class="song"> （生态环境部负责） </span>
          </p>
          <p>
            <span class="song">（七）强化执法监测。</span>
            健全执法和监测机构协同联动快速响应的工作机制，按照排污许可执法监管需求开展执法监测，确保执法取证及时到位、数据准确、
            报告合法。加大排污单位污染物排放浓度、排放量以及停限产等特殊时段排放情况的抽测力度。开展排污单位自行监测方案、自行
            监测数据、自行监测信息公开的监督检查。鼓励有资质、能力强、信用好的社会环境监测机构参与执法监测工作。
            <span class="song"> （生态环境部负责） </span>
          </p>
          <p>
            <span class="song">（八）健全执法监管联动机制。</span>
            强化排污许可日常管理、环境监测、执法监管联动，加强信息共享、线索移交和通报反馈，构建发现问题、督促整改、问题销号的
            排污许可执法监管联动机制。加强与环境影响评价工作衔接，将环境影响评价文件及批复中关于污染物排放种类、浓度、数量、方
            式及特殊监管要求纳入排污许可证，严格按证执法监管。做好与生态环境损害赔偿工作衔接，明确赔偿启动的标准、条件和部门职
            责，推进信息共享和结果双向应用。
            <span class="song"> （生态环境部负责） </span>
          </p>
          <p>
            <span class="song">（九）严惩违法行为。</span>
            将排污许可证作为生态环境执法监管的主要依据，加大对无证排污、未按证排污等违法违规行为的查处力度。对偷排偷放、自行监
            测数据弄虚作假和故意不正常运行污染防治设施等恶意违法行为，综合运用停产整治、按日连续处罚、吊销排污许可证等手段依法
            严惩重罚。情节严重的，报经有批准权的人民政府批准，责令停业、关闭。构成犯罪的，依法追究刑事责任。加大典型违法案件公
            开曝光力度，形成强大震慑。
            <span class="song">
              （生态环境部、公安部，地方有关人民政府按职责分工负责）
            </span>
          </p>
          <p>
            <span class="song">（十）加强行政执法与刑事司法衔接。</span>
            建立生态环境部门、公安机关、检察机关联席会议制度，完善排污许可执法监管信息共享、案情通报、证据衔接、案件移送等生态
            环境行政执法与刑事司法衔接机制，规范线索通报、涉案物品保管和委托鉴定等工作程序。鼓励生态环境部门和公安机关、检察机
            关优势互补，提升环境污染物证鉴定与评估能力。
            <span class="song">
              （生态环境部、公安部、最高人民检察院、最高人民法院按职责分工负责）
            </span>
          </p>

          <h3>四、优化执法方式</h3>
          <p>
            <span class="song">（十一）完善“双随机、一公开”监管。</span>
            深化“放管服”改革，按照“双随机、一公开”监管工作要求，将排污许可发证登记信息纳入执法监管数据库，采取现场检查和远程核查
            相结合的方式，对排污许可证及证后执行情况进行随机抽查。设区的市级生态环境部门要按照排污许可履职要求，根据执法监管力量、
            技术装备和经费保障等情况统筹制定年度现场检查计划并按月细化落实。对存在生态环境违法问题、群众反映强烈、环境风险高的排
            污单位，增加抽查频次和执法监管力度。检查计划、检查结果要及时、准确向社会公开。
            <span class="song"> （生态环境部负责） </span>
          </p>
          <p>
            <span class="song">（十二）实施执法正面清单。</span>
            进一步加强生态环境执法正面清单管理，综合考虑排污单位环境管理水平、污染防治设施运行和维护情况、守法状况等因素设定清单
            准入条件，优先将治污水平高、环境管理规范的排污单位纳入清单。推动排污许可差异化执法监管，对守法排污单位减少现场检查次
            数。将存在恶意偷排、篡改台账记录、逃避监管等行为的排污单位及时移出清单。
            <span class="song"> （生态环境部负责） </span>
          </p>
          <p>
            <span class="song">（十三）推行非现场监管。</span>
            将非现场监管作为排污许可执法监管的重要方式，完善监管程序，规范工作流程，落实责任要求。建立健全数据采集、分析、预警、
            督办、违法查处、问题整改等排污许可非现场执法监管机制。依托全国排污许可证管理信息平台开展远程核查。加强污染源自动监控
            管理，推行视频监控、污染防治设施用水（电）监控，开展污染物异常排放远程识别、预警和督办。
            <span class="song"> （生态环境部负责） </span>
          </p>
          <p>
            <span class="song">（十四）规范行使行政裁量权。</span>
            2022年6月底前，省级生态环境部门因地制宜补充细化排污许可处罚幅度相关规定。对初次实施未依法填报排污许可登记表、环境
            管理台账记录数据不全、未按规定提交排污许可证执行报告或未按规定公开信息等违法行为且危害后果轻微并及时改正的，依法可以
            不予行政处罚。鼓励有条件的设区的市级生态环境部门对排污许可行政处罚裁量规则和基准进行细化量化，进一步规范行使自由裁量权。
            <span class="song"> （生态环境部负责） </span>
          </p>
          <p>
            <span class="song">（十五）实施举报奖励。</span>
            将举报排污许可违法行为纳入生态环境违法行为举报奖励范围，优化奖励发放方式、简化发放流程，对举报人信息严格保密。对举
            报重大生态环境违法行为、安全隐患和协助查处重大案件的，实施重奖。开展通俗易懂、覆盖面广、针对性强的举报奖励宣传。2022年
            6月底前，设区的市级以上地方生态环境部门建立实施举报奖励制度。
            <span class="song"> （生态环境部负责） </span>
          </p>
          <p>
            <span class="song">（十六）加强典型案例指导。</span>
            生态环境部建立排污许可典型案例收集、解析和发布机制，完善典型案例发布的业务审核、法律审核和集体审议决定制度。设区的
            市级以上地方生态环境部门要积极开展案件总结、分析和报送工作，加强典型案例发布宣传，扩展典型案例应用，发挥警示教育作用。
            <span class="song"> （生态环境部负责） </span>
          </p>

          <h3>五、强化支撑保障</h3>
          <p>
            <span class="song">（十七）完善标准和技术规范。</span>
            加快制定修订重点行业排污许可证申请与核发技术规范、自行监测技术指南。完善排污单位自主标记数据有效性判定规则，强化自
            动监测设备的计量管理。出台污染物排放量核算技术方法和污染物排放超标判定规则。
            <span class="song">
              （生态环境部、市场监管总局按职责分工负责）
            </span>
          </p>
          <p>
            <span class="song">（十八）加强技术和平台支撑。</span>
            强化排污许可执法监管信息化建设，推进全员、全业务、全流程使用生态环境移动执法系统查办案件。加强固定污染源管理与监控
            能力建设，加快全国排污许可证管理信息平台与移动执法系统互联互通，强化排污许可执法监管有效信息技术支撑。
            <span class="song"> （生态环境部、财政部按职责分工负责） </span>
          </p>
          <p>
            <span class="song">（十九）加快队伍和装备建设。</span>
            按照机构规范化、装备现代化、队伍专业化、管理制度化的要求开展执法机构标准化建设。鼓励各地按有关规定建立办案立功受奖
            激励机制。将排污许可执法监管经费列入本级预算，将生态环境执法用车纳入执法执勤车辆序列，配齐配全执法调查取证设备，有
            条件的地区加快配备无人机（船）等高科技执法装备。全面落实执法责任制，规范排污许可执法程序，健全内部约束和外部监督机
            制，建立插手干预监督执法记录制度，明确并严格执行执法人员行为规范和纪律要求，对失职渎职、以权谋私、包庇纵容等违法违
            规行为严肃查处。
            <span class="song">
              （生态环境部、人力资源社会保障部、财政部按职责分工负责）
            </span>
          </p>
          <p>
            <span class="song">（二十）强化环保信用监管。</span>
            建立排污许可守法和诚信信息共享机制，强化排污许可证的信用约束。将申领排污许可证的排污单位纳入环保信用评价制度，加强环
            保信用信息归集共享，强化评价结果应用，实施分级分类监管，做好与生态环境执法正面清单衔接。
            <span class="song">
              （生态环境部、国家发展改革委按职责分工负责）
            </span>
          </p>
          <p>
            <span class="song">（二十一）鼓励公众参与。</span>
            生态环境部门要依法主动公开排污许可核发和执法监管信息，接受社会监督，积极听取有关方面意见建议。搭建公众参与和沟通平台，
            完善政府、企业、公众三方对话机制，开辟有效的意见交流和投诉渠道。对公众反映的排污许可等生态环境问题，积极调查处理并反馈
            信息。充分发挥新媒体作用，及时解读相关政策，为公众解疑释惑，支持新闻媒体进行舆论监督。
            <span class="song"> （生态环境部负责） </span>
          </p>
          <p>
            <span class="song">（二十二）加强普法宣传</span>
            按照“谁执法、谁普法”原则，建立排污许可普法长效机制。突出现场检查的普法宣传，推行全程说理式执法，推广说理式执法文书。
            组织“送法入企”活动，举办普法培训，开展执法帮扶，营造良好的排污许可守法环境。
            <span class="song"> （生态环境部负责） </span>
          </p>

          <!-- ------------------------------------------------------------------------------ -->

          <!-- 宣传部分 -->
          <p style="color: #ff0000; font-size: 12px; font-weight: 700">
            声明：信息来源于网络，转载、分享文章旨在进行交流和探讨，与本站立场无关，版权归原作者所有，如涉及侵权问题请联系后台管理人员做删稿处理。
          </p>
          <p>
            不进厂检查并不意味着不对企业监管。以信息化手段实现科学监管、精准监管提高非现场执法能力、让企业自觉守法是当务之急。
          </p>
          <p>
            北京中泽宇华环境科技有限公司自主研发环保综合管理软件，系统内置13大项预警报警模块，对废气在线监测、废水在线监测、治理设施
            用电、用水数据、排污许可、自行监测、视频等数据进行
            <i style="color: #ff0000; font-weight: 700">多维度联动分析，</i>
            自动诊断异常数据并将预警报警数据推送至相关负责人，<i
              style="color: #ff0000; font-weight: 700"
              >极大 提高远程监管、精准执法的能力。</i
            >
            同时企业可通过APP、微信、PC端实时查看企业环保设施运行情况，如有异常
            <i style="color: #ff0000; font-weight: 700"
              >及时处理、及时整改，有效降低环保处罚风险和因处理不及时带来的环境影响。</i
            >
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/advertise001.png"
            alt=""
          />
          <img
            src="../../../assets/images/dynamicInformation/Information/advertise002.png"
            alt=""
            style="padding: 20px 0"
          />
          <img
            src="../../../assets/images/dynamicInformation/Information/advertise003.png"
            alt=""
          />
          <p style="text-indent: 0">
            中泽宇华专注环保管理软件开发，因为专注，所以专业，欢迎咨询！<br />
            地址：北京市大兴区西红门兴创国际中心S座809室 <br />
            武汉市经济开发区东合中心E座506室<br />
            联系人：方经理 联系电话：18510508157（微信同号）<br />
            联系人：刘经理 联系电话： 010-80251293 、13407191262（微信同号）
          </p>
          <br />
        </div>
      </div>
    </div>
    <div class="foot">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from "@/views/header/Header.vue";
import Footer from "@/views/footer/Footer.vue";
export default {
  components: { Header, Footer },

  data() {
    return {};
  },
  created() {
    this.$store.state.menu = 4;
  },
};
</script>
<style
  lang="scss"
  src="../../../assets/css/dynamicInformation/Information.scss"
></style>
